import * as React from "react";
import { DefaultConfig } from "./models";

const { Provider, Consumer } = React.createContext(DefaultConfig);

export const ConfigProvider = Provider;
export const ConfigConsumer = Consumer;
